export default {
  title: "Profil",
  description: "Verwalten Sie Ihr persönliches Profil",
  personalInfo: "Persönliche Informationen",
  weddingInfo: "Hochzeitsinformationen",
  form: {
    firstName: "Vorname",
    lastName: "Nachname",
    email: "E-Mail",
    phone: "Telefon",
    weddingDate: "Hochzeitsdatum",
    partnerName: "Partnername",
    venue: "Veranstaltungsort",
    location: "Ort",
    about: "Über",
    save: "Änderungen speichern"
  },
  actions: {
    save: "Speichern",
    cancel: "Abbrechen",
    edit: "Bearbeiten"
  },
  messages: {
    profileUpdated: "Profil erfolgreich aktualisiert",
    error: "Ein Fehler ist aufgetreten",
    updateSuccess: "Profil erfolgreich aktualisiert",
    updateError: "Fehler beim Aktualisieren des Profils",
    photoUploadSuccess: "Foto erfolgreich hochgeladen",
    photoUploadError: "Fehler beim Hochladen des Fotos"
  },
  photo: {
    alt: "Profilbild",
    upload: "Ein Foto hochladen",
    change: "Foto ändern",
    remove: "Foto löschen"
  }
};
